import { Loader2Icon } from "lucide-react";

import { cn } from "~/lib/utils";

function Spinner({
  className,
  ...props
}: React.ComponentProps<typeof Loader2Icon>) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("ekv:size-4 ekv:animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
